import { LitElement, html, css } from 'lit';
import { speechBubble, info } from '../../utilities/icons';
import { close } from '../../utilities/icons';
import { accessibility } from '../../utilities/styles';
import { decodeEntities } from '../../utilities/formsUtilities';
export class AllInTooltip extends LitElement {
    static currentlyOpenTooltip = null;
    static properties = {
        buttonText: { type: String },
        buttonTextDisplay: { attribute: false },
        buttonTitle: { type: String },
        tooltip: { type: String },
        inline: { type: String },
        icon: { type: String },
        label: { type: String },
        modalLeft: { type: Boolean },
    };
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        //this._handleHideReveal();
        this.computeButtonText();
        this.id = `tooltip_${Math.random().toString(36).substring(7)}`;
        /* if(this.tooltip){
            this.tooltip = decodeEntities(this.tooltip);
        } */
        if (!this.icon) {
            this.icon = info;
        }
        else if (this.icon == 'speechBubble') {
            this.icon = speechBubble;
        }
        else {
            this.icon = info;
        }
    }
    updated() {
        this.renderRoot.querySelector(`#${this.id}`).innerHTML = this.tooltip;
    }
    get button() {
        return this.renderRoot.querySelector('.trigger');
    }
    get modal() {
        return this.renderRoot.querySelector('.tooltip_modal');
    }
    get closer() {
        return this.renderRoot.querySelector('.close');
    }
    render() {
        //generate a unique id for the tooltip
        if (this.inline == 'true') {
            return html `\n            <div class="tooltip_wrapper inline">\n                <button type="button" class="tooltip trigger" aria-label="${this.buttonText}" title="${this.buttonTitle}" @click=${this.openClose}>${this.buttonTextDisplay || this.buttonText}<span aria-hidden="true">${this.icon}</span></button>\n                <div class="tooltip_modal" id="" role="dialog" aria-label="Tooltip" aria-describedby="${this.id}"><h4><span aria-hidden="true">${this.icon}</span>${this.buttonText}</h4><div id="${this.id}"></div><button class="close" @click=${this.openClose}><span aria-hidden="true">${close}</span><span class="screen-reader-text">Cau Blwch Testun</span></button></div>\n            </div>\n            `;
        }
        else {
            return html `\n            <div class="tooltip_wrapper">\n                <button type="button" class="tooltip trigger" aria-label="${this.buttonText}" title="${this.buttonTitle}" @click=${this.openClose}>${this.buttonTextDisplay || this.buttonText}<span aria-hidden="true">${this.icon}</span></button>\n                <div class="tooltip_modal" id="" role="dialog" aria-label="Tooltip" aria-describedby="${this.id}"><h4>${this.buttonText}</h4><p id="${this.id}"></p><button class="close" @click=${this.openClose}><span aria-hidden="true">${close}</span><span class="screen-reader-text">Cau Blwch Testun</span></button></div>\n            </div>\n            `;
        }
    }
    openClose(e) {
        e.preventDefault();
        //
        if (this.modal.classList.contains('open')) {
            this.close();
        }
        else {
            this.open(e);
        }
    }
    // open(e=false){
    //     this.modal.classList.add('open');
    //     let rect = this.modal.getBoundingClientRect();
    //     let winDiff = window.innerWidth - (rect.left + rect.width);
    //     if(winDiff < 0){
    //         this.modal.style.right = `${winDiff * -1 + 20}px`;
    //     }
    //     else{
    //         this.modal.style.right = null;
    //     }
    //     this.closer.focus();
    //     //this._scrollHandler = this.close.bind(this);
    //     this._keyHandler = this.keyHandler.bind(this);
    //     this._clickHandler = this.closeOnClickOff.bind(this);
    //     this.modal.addEventListener("keydown", this._keyHandler);
    //     //this.modal.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     if(e){
    //         e.stopPropagation();
    //     }
    //     document.addEventListener("click", this._clickHandler);
    //    /*  setTimeout(() => {
    //         document.addEventListener("scroll", this._scrollHandler);
    //     },500); */
    // }
    open(e = false) {
        // Close any previously open tooltip
        if (AllInTooltip.currentlyOpenTooltip &&
            AllInTooltip.currentlyOpenTooltip !== this) {
            AllInTooltip.currentlyOpenTooltip.close(false);
        }
        // Mark this tooltip as the currently open one
        AllInTooltip.currentlyOpenTooltip = this;
        this.modal.classList.add('open');
        let rect = this.modal.getBoundingClientRect();
        let winDiff = window.innerWidth - (rect.left + rect.width);
        if (winDiff < 0) {
            this.modal.style.right = `${winDiff * -1 + 20}px`;
        }
        else {
            this.modal.style.right = null;
        }
        if (this.modalLeft) {
            this.modal.style.left = "unset";
            this.modal.style.right = "0.25rem";
            this.modal.style.transform = "scale(1)";
            this.modal.style.top = "-1.5rem";
        }
        this.closer.focus();
        this._keyHandler = this.keyHandler.bind(this);
        this._clickHandler = this.closeOnClickOff.bind(this);
        this.modal.addEventListener("keydown", this._keyHandler);
        document.addEventListener("click", this._clickHandler);
        if (e) {
            e.stopPropagation();
        }
    }
    close(returnFocus = true) {
        this.modal.classList.remove('open');
        if (returnFocus) {
            this.button.focus();
        }
        this.modal.removeEventListener("keydown", this._keyHandler);
        document.removeEventListener("click", this._clickHandler);
        document.removeEventListener("scroll", this._scrollHandler);
        // Clear the global reference if this tooltip was open
        if (AllInTooltip.currentlyOpenTooltip === this) {
            AllInTooltip.currentlyOpenTooltip = null;
        }
    }
    keyHandler(e) {
        console.log(e);
        if (e.key == "Escape") {
            e.preventDefault();
            this.close();
        }
        if (e.key == 'Tab') {
            e.preventDefault();
            this.closer.focus();
        }
    }
    closeOnClickOff(e) {
        if (e.target == this.button || e.target == this || e.target.closest('.tooltip_modal') || e.target.closest('.trigger')) {
            return;
        }
        else {
            this.close();
        }
    }
    computeButtonText() {
        if (!this.buttonText) {
            let labelText = '';
            // Look for a label inside this component
            const localLabel = this.querySelector('label');
            if (localLabel) {
                labelText = localLabel.textContent?.trim();
            }
            // Closest ancestor label
            if (!labelText) {
                labelText = this.closest('label')?.textContent?.trim();
            }
            // Fallback: look for a label in nearest .input-group outside shadow DOM
            // if (!labelText) {
            //     const inputGroup = this.getRootNode().host
            //         ? this.getRootNode().host.closest('.input-group', '.provision') 
            //         : this.closest('.input-group','.provision');
            //     const groupLabel = inputGroup?.querySelector('label');
            //     labelText = groupLabel?.textContent?.trim();
            // }
            // Fallback: look for a label in nearest .input-group outside shadow DOM
            if (!labelText) {
                const inputGroup = this.closest('.input-group');
                const groupLabel = inputGroup?.querySelector('label');
                labelText = groupLabel?.textContent?.trim();
            }
            // Additional fallback for provision-based layouts
            if (!labelText) {
                const provision = this.closest('.provision');
                const groupLabel = provision?.querySelector('.input-group label');
                labelText = groupLabel?.textContent?.trim();
            }
            // Set buttonText
            this.buttonText = labelText
                ? `Beth mae ${labelText} yn ei olygu?` : `Beth mae hyn yn ei olygu?`;
            // Set buttonText display to add strong tag without breaking aria-label and other attributes that need buttonText as plain text
            this.buttonTextDisplay = labelText
                ? html `Beth mae <strong>${labelText}</strong> yn ei olygu?` : this.buttonText;
            // Set buttonTitle to display when hovering over the button
            this.buttonTitle = labelText
                ? `Cliciwch i gael help ar ${labelText}` : this.buttonText;
        }
    }
    static styles = [
        accessibility,
        css `
            .tooltip_wrapper{
                position: relative;
                display: block;
            }

            .trigger {
                color: #472961;
                display: flex;
                align-items: center;
                border:none;
                background-color: transparent;
                padding: 0;
                gap:0.25rem;
                font-weight:600;
                text-decoration: underline;
                font-family: var(--allin-font,'montserrat');
                font-size: 1rem;
            }
            .tooltip.trigger{
                display: inline;
                cursor: pointer;
                text-decoration: none;
            }
            button{
                cursor: pointer;
                display: flex;
                align-items: center;
                border:none;
            }
            .tooltip_modal {
                background-color: var(--color-primary-lighter);
                right: 0;
                width:300px;
                max-width: 90vw;
                padding: 2rem 1rem;
                opacity: 0;
                transform: scale(0) translate(50%,-50%);
                transition-behavior: allow-discrete;
                transition: opacity calc(var(--transition) / 2) ease,
                    transform var(--move-transition) ease, display var(--transition) ease;
                transform-origin: 100% 0;
                display: none;
                z-index:100;
                scroll-margin-top: var(--header-height);
                position: absolute;
                outline: 3px solid #472961;
                outline-offset: 0px;
                text-align: left;
            }
            .tooltip_modal.open  {
                margin-top:1rem;
                opacity: 1;
                transform: scale(1) translate(50%,-50%);
                display: block;
                outline-offset: 0;
            }
            @media (min-width: 1200px){
                .tooltip_modal {
                    position: absolute;
                }
                .tooltip_modal.open{
                    transform: scale(1) translate(50%,-50%);
                }
            }
            button.tooltip.trigger{
                display: inline;
                text-align: left;
                text-decoration: none;
            }
            button.tooltip.trigger svg,
            a.tooltip.trigger svg{
                background-color: #ffc845;
                border-radius: 50%;
            }

            @media (forced-colors: active) {
                button.tooltip.trigger{
                    text-decoration: underline;
                }
            }
            
            h4{
                margin-top:0;
            }

            p{
                margin-bottom:0;
            }
            .tooltip_modal img{
                width: 50px;
                height: 50px;
                object-fit: contain;
                display:block;
                margin:0.5rem 0;
            }
            button.close {
                color: var(--color-white-to-black);
                background-color: #000;
                transition: background-color var(--transition) ease;
                padding: 0.5rem;
                line-height: 0;
                position: absolute;
                top: 0;
                right: 0;
            }
            button.close:focus {
                outline: 2px solid var(--color-primary);
                outline-offset: 0px;
            }

            button.close:hover{
                background-color: var(--color-primary-lighter-to-secondary-lighter);
            }

            .tooltip_wrapper.inline{
                display: inline;
                
            }
            
            .tooltip_wrapper.inline .tooltip_modal {
                right:unset;
                left:calc(100% + 2rem);
                top:0;
                transform: scale(0) translateY(-50%);
                
            }
            .tooltip_wrapper.inline .tooltip_modal.open  {
                transform: scale(1) translateY(-50%);
            }

            h4:has(svg){
                display: flex;
                align-items: center;
                gap: 0.5rem;
            }
            .trigger svg, h4 svg{
                width: 1.2rem;
                height: 1.2rem;
                fill:  #472961;;
            }
            .trigger svg path,h4 svg path{
                fill:  #472961;
            }
            a{
                color: var(--color-secondary);
            }
        `
    ];
}
